import { MoneyWavy, Question, Gear } from '@phosphor-icons/react'
import StoreSelector from './StoreSelector'
import useNavigation from 'src/lib/hooks/useNavigation'
import { useUser } from 'src/lib/contexts/UserContext'
import { classNames } from 'src/lib/utils/helpers'
import { permissionType } from 'src/lib/utils/constants'
import { Icon } from '@shopflo/ui'

const PopoverNavigationMenu = ({ closePopover }: { closePopover: () => void }) => {
  const {
    actions: { resetAndRedirect }
  } = useNavigation()

  const { user, canAccess, isUserConfigured } = useUser()

  const navigationItems = [
    {
      title: 'Billing',
      icon: MoneyWavy,
      path: '/billing',
      disabled: !canAccess(permissionType.TAB_INVOICES, 0) || !isUserConfigured,
      id: 'tab-invoices'
    },
    {
      title: 'Support',
      icon: Question,
      path: '/support',
      disabled: !canAccess(permissionType.TAB_SUPPORT, 0) || !isUserConfigured,
      id: 'tab-support'
    },
    {
      title: 'Settings',
      icon: Gear,
      path: '/settings',
      disabled: !canAccess(permissionType.TAB_SETTINGS, 0) || !isUserConfigured,
      id: 'tab-settings'
    }
  ]
  return (
    <div className='p-1.5 '>
      {user?.organisations && user?.organisations?.length > 3 && <StoreSelector />}
      {navigationItems.map(item => {
        return (
          <div
            id={item.id}
            key={item.title}
            className={classNames(
              'flex items-center justify-between px-2 py-1.5 hover:bg-zinc-100 rounded-md ',
              item.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            )}
            onClick={() => {
              if (item.disabled) return
              closePopover()
              resetAndRedirect(item.path)
            }}
            aria-disabled={item.disabled}
          >
            <div className='flex items-center gap-2'>
              <Icon IconComponent={item.icon} size='sm' className='text-zinc-500' />
              <p className='text-zinc-600 text-text-sm-regular'>{item.title}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default PopoverNavigationMenu
